export type ValidationErrors = Record<string, string>;

/**
 * 個別フィールドのバリデーター関数群
 */
export const validators = {
  /** 必須チェック（スペースのみもNG） */
  required: (value: string, label: string, customMsg?: string): string =>
    !value.trim() ? (customMsg ?? `${label}を入力してください`) : '',

  /** メールアドレス形式チェック（必須込み、スペースのみも未入力扱い） */
  emailTrimmed: (value: string): string => {
    if (!value.trim()) return 'メールアドレスを入力してください';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()))
      return '正しいメールアドレスを入力してください';
    return '';
  },

  /** 最大文字数チェック（ラベル付きメッセージ対応） */
  maxLength: (value: string, max: number, label?: string): string =>
    value.length > max
      ? `${label ? `${label}を` : ''}${max}文字以内で入力してください`
      : '',

  /** 最大文字数チェック（入力がある場合のみ） */
  optionalMaxLength: (value: string, max: number, label?: string): string =>
    value.length > 0 && value.length > max
      ? `${label ? `${label}を` : ''}${max}文字以内で入力してください`
      : '',

  /** ひらがなチェック（入力がある場合のみ） */
  hiragana: (value: string): string => {
    if (!value) return '';
    if (!/^[\u3040-\u309F\s\u3000]+$/.test(value))
      return 'ふりがなはひらがなで入力してください';
    return '';
  },

  /** 日本語文章チェック（ひらがなが1文字以上含まれること。未入力はスキップ） */
  containsHiragana: (value: string, label?: string): string => {
    if (!value.trim()) return '';
    if (!/[\u3040-\u309F]/.test(value)) {
      return `${label ?? '内容'}は日本語（ひらがなを含む文章）でご入力ください`;
    }
    return '';
  },

  /** 年齢チェック（数字のみ・任意） */
  age: (value: string): string => {
    if (!value) return '';
    if (!/^\d+$/.test(value)) return '年齢は数字のみで入力してください';
    return '';
  },

  /** 電話番号チェック（数字のみ・ハイフンなし） */
  phone: (value: string): string => {
    if (!value.trim()) return '電話番号を入力してください';
    if (!/^\d+$/.test(value)) return '電話番号は数字のみで入力してください。';
    if (value.length < 10 || value.length > 11) return '電話番号は10〜11桁で入力してください';
    return '';
  },
};

export interface ValidationRule {
  field: string;
  value: string;
  checks: ((v: string) => string)[];
}

/**
 * 複数フィールドをまとめてバリデーションする
 * @returns エラーオブジェクト（空なら全てOK）
 */
export const validateFields = (rules: ValidationRule[]): ValidationErrors => {
  const errors: ValidationErrors = {};
  rules.forEach(({ field, value, checks }) => {
    for (const check of checks) {
      const error = check(value);
      if (error) {
        errors[field] = error;
        break;
      }
    }
  });
  return errors;
};